import { Directive, Input, HostListener } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Directive({
  selector: '[miqGoBackLink]',
  standalone: false,
})
export class GoBackLinkDirective {
  @Input() miqGoBackLinkWithRoute: string[];

  constructor(
    private location: Location,
    private router: Router
  ) {}

  @HostListener('click')
  onClick() {
    if (!this.miqGoBackLinkWithRoute) {
      this.location.back();
    } else {
      this.router.navigate(this.miqGoBackLinkWithRoute);
    }
  }
}
